import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommentsService } from '../../comments.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'lib-unseen-comments-icon',
    templateUrl: './unseen-comments-icon.component.html',
    styleUrls: ['./unseen-comments-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnseenCommentsIconComponent implements OnInit {
  unseenThreadsCount$ = this.commentsService.unseen$.pipe(
    map((threads) => threads.length)
  );

  @Output() smartPreviewOpen = new EventEmitter();
  @Output() smartPreviewVisited = new EventEmitter();

  constructor(private commentsService: CommentsService) {}

  ngOnInit(): void {}
}
